// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__3XyzV","sectionHeader":"Section_sectionHeader__20afD","checkTileWrapper":"Section_checkTileWrapper__2S4un","count":"Section_count__37-Tj"};